export const i18nBusiness = {
  model_type: {
    pdm: 'pdm',
    condition_based: 'Condition based',
    regression: 'Regression',
  },
  model_view: {
    title: 'Vista del modelo',
    high: 'Alto',
    medium: 'Medio',
    good: 'Bueno',
  },
  alarm: {
    status: {
      anomaly_detected: 'Anomalía detectada',
      risk_of_failure: 'Riesgo de falla',
      under_investigation: 'En investigación',
      closed: 'Cerrado',
    },
    classification: {
      need_intervention: 'Intervención necesaria',
      no_action_needed: 'No se necesita acción',
      inappropriate_limits: 'Límites inapropiados',
      instrumentation_problem: 'Problema de instrumentación',
      others: 'Otro',
      real_alarm: 'Verdadera alarma',
      false_alarm: 'Falsa alarma',
      useful: 'Útil',
      not_useful: 'Inútil',
    },
    action: {
      none: 'Ninguna',
      cleaning: 'Limpieza',
      repair: 'Reparo',
      machine_restart: 'Reinicio de la máquina',
      parameters_adjustments: 'Ajuste de parámetros',
      parts_replacement: 'Cambio de piezas',
      others: 'Otros',
    },
    reason: {
      process_instability: 'Inestabilidad del proceso',
      resumption_production: 'Reanudación de la producción',
      instrumentation_problem: 'Problema de instrumentación',
      process_change: 'Cambio en proceso',
      tests_in_progress: 'Tests en curso',
      not_sure: 'No hay certeza',
      insufficient_time: 'Tiempo insuficiente',
      action_not_effective: 'Acción ineficaz',
      inappropriate_limits: 'Limites inapropriados',
      uncalibrated_model: 'Modelo descalibrado',
      others: 'Otros',
    },
  },
  sensor: {
    status: {
      active: { active: 'activo', active_one: 'activo', active_other: 'activos' },
      delayed: { delayed: 'tardío', delayed_one: 'tardío', delayed_other: 'tardíos' },
      no_data: { no_data: 'sin datos', no_data_one: 'sin dato', no_data_other: 'sin datos' },
      offline: {
        offline: 'desconectado',
        offline_one: 'desconectado',
        offline_other: 'desconectados',
      },
    },
  },
  pump_curve: {
    kpi: {
      power_calculated: 'Power calculated',
      power_expected: 'Power exp',
      density: 'Density',
      efficiency: 'Efficiency',
      efficiency_expected: 'Efficiency exp',
      rotation: 'Rotation',
      flow_rate: 'Flow rate',
      pressure_discharge: 'Pressure dis',
      box_level: 'Box level',
      npsha: 'NPSHa',
      npshr: 'NPSHr',
    },
  },
};
